export var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["QUEUED"] = "queued";
    TransactionStatus["DROPPED"] = "dropped";
    TransactionStatus["REPLACED"] = "replaced";
    TransactionStatus["PENDING"] = "pending";
    TransactionStatus["REVERTED"] = "reverted";
    TransactionStatus["CONFIRMED"] = "confirmed";
})(TransactionStatus || (TransactionStatus = {}));
export const FINISHED_STATUS = [
    TransactionStatus.CONFIRMED,
    TransactionStatus.REVERTED,
    TransactionStatus.DROPPED,
    TransactionStatus.REPLACED
];
export const FAILED_STATUS = [
    TransactionStatus.DROPPED,
    TransactionStatus.REVERTED
];
export const SUCCESS_STATUS = [
    TransactionStatus.REPLACED,
    TransactionStatus.CONFIRMED
];
//# sourceMappingURL=types.js.map